import { makeRequest } from "../../baseApi";
import { parseResponseDefault } from "../../not-sorted.utils";
import { normilizeShortcut, processCode } from "./utils";
import { makeParamsString } from "../../utils";
import { getBiblePubnr } from "@/shared/utils/search/advanced/advanced";

/**
 * Note from the old code: OMSK search is used  via redirect from /related/search/en/egw_phrase:000
 */

export const searchSuggestionsRequest = (searchValue) => {
  const { query, langs } = searchValue;
  const langsString = langs && langs.length ? "&" + makeParamsString({ lang: langs }, true) : "";
  return makeRequest({
    url: `search/suggestions?query=${encodeURIComponent(query)}${langsString}`,
    type: "get",
    memoryCache: true,
    parseResponse: parseResponseDefault,
  });
};

/**
 *
 * @typedef {Object} ShortcutParams
 * @property {string} query
 * @property {string} cutQuery
 * @property {string} bookId
 * @property {?string} paraId
 * @property {string} shortCutType
 * @property {number} hits
 * @property {string} title
 */

export const getSearchSuggestionsShortcutRequest = (query, bibleId, langs) => {
  const params = [`query=${encodeURIComponent(query)}`, `bible_id=${bibleId}`];
  if (langs && langs.length) {
    params.push(makeParamsString({ lang: langs }, true));
  }
  return makeRequest({
    url: `search/suggestions/shortcut?${params.join("&")}`,
    type: "get",
    memoryCache: true,
    parseResponse: (response) => {
      const data = response.data;
      if (!data) {
        return null;
      }
      return normilizeShortcut(data, query);
    },
  });
};

export const getSearchSuggestionsRequest = (query, empty) => {
  return makeRequest({
    url: `search/suggestions?query=${encodeURIComponent(query)}&empty=${empty}`,
    type: "get",
    memoryCache: true,
    parseResponse: (response) => {
      const data = response.data;
      return data.map((item) => normilizeShortcut(item, query));
    },
  });
};

export const searchNavProcess = async (query, baseBible, langs) => {
  const [query1] = processCode(query);
  const bibleId = getBiblePubnr(baseBible);

  return await getSearchSuggestionsShortcutRequest(query1, bibleId, langs);
};
